import React, {Suspense, useEffect, useState} from 'react';
import { DateRange } from '@mui/x-date-pickers-pro/DateRangePicker';

import Calendar from '../../../../../helpers/class/Calendar';
import Checkers from '../../../../../helpers/class/Checkers';
import Dialog from '../../../../../helpers/class/Dialog';
import Popover from '../../../../../helpers/class/Popover';

import BookNowViewPort from './right/BookNowViewPort';
import dynamic from "next/dynamic";
import {useDispatch, useSelector} from "react-redux";
import {fetchSinglePropertyData, setAdults, setInfants, setKids} from "../../../../../redux/actions";
import {fetchBuilderSettingByKey} from "../../../../../helpers/MethodHelper";
import StickyBookNow from "./right/StickyBookNowViewPort";

const SwipeableDrawerBooknow = dynamic(() => import("./right/SwipeableDrawerBooknow"), {
  ssr: false,
})

export default function RightSide ( props ) {

  Calendar.setProps( props );
  Popover.setProps( props );
  Dialog.setProps( props );

  const calendarMaterialTheme = Calendar.getCalendarMaterialTheme;
  const popoverMaterialTheme = Popover.getPopoverMaterialTheme;
  const dialogMaterialTheme = Dialog.getDialogMaterialTheme;

  const [ value, setValue ] = React.useState<DateRange<Date>>([ null, null ]);

  //-------------POP OVER----------------
  const [ popover_anchorEl, popover_setAnchorEl ] = React.useState<HTMLButtonElement | null>( null );
  const popover_handleOpen = ( event: React.MouseEvent<HTMLButtonElement> ) => {
    popover_setAnchorEl( event.currentTarget );
    document.getElementById( 'guests_label' ).classList.add( 'fade' );
    document.getElementById( 'guests_label' ).parentElement.classList.add( 'focused' );
  };

  const popover_handleClose = () => {
    document.getElementById( 'guests_label' ).classList.remove( 'fade' );
    document.getElementById( 'guests_label' ).parentElement.classList.remove( 'focused' );
    popover_setAnchorEl( null );
  };
  const popover_open = Boolean( popover_anchorEl );
  const popover_id = popover_open ? 'simple-popover' : undefined;

  const [ adults_amount, adults_setAmount ] = useState( 0 );
  const [ kids_amount, kids_setAmount ] = useState( 0 );
  const [ infants_amount, infants_setAmount ] = useState( 0 );

  const [ adults_decreaseHidden, adults_setDecreaseHidden ] = useState( true );
  const [ kids_decreaseHidden, kids_setDecreaseHidden ] = useState( true );
  const [ infants_decreaseHidden, infants_setDecreaseHidden ] = useState( true );
  const [ adults_increaseHidden, adults_setIncreaseHidden ] = useState( false );
  const [ kids_increaseHidden, kids_setIncreaseHidden ] = useState( false );
  const [ infants_increaseHidden, infants_setIncreaseHidden ] = useState( false );

  const [ guests_text, guests_setText ] = useState( 'Who' );

  // const singlePropertyData = useSelector(state => state['singlePropertyData']['propertyData'])
  //
  // const chainId = singlePropertyData && singlePropertyData.chain_id ? singlePropertyData.chain_id : null
  //
  // const [chain, setChain] = useState(chainId)
  //
  // useEffect(() => {
  //   setChain(chainId)
  // }, [chainId])
  //
  const adults_handleIncrease = () => {
    adults_setAmount( adults_amount => adults_amount + 1 );

    if ( ( adults_amount + 1 ) > 0 )
      adults_setDecreaseHidden( false );
    else
      adults_setDecreaseHidden( true );

    if ( ( adults_amount + 1 ) < 30 )
      adults_setIncreaseHidden( false );
    else
      adults_setIncreaseHidden( true );

    guests_setText( () => guestsTextCalc( ( adults_amount+1 ), kids_amount, infants_amount ) )
  };
  const adults_handleDecrease = () => {
    adults_setAmount( adults_amount => adults_amount - 1 );

    if ( ( adults_amount - 1 ) < 1 )
      adults_setDecreaseHidden( true );
    else
    if ( ( kids_amount > 0 || infants_amount > 0 ) && ( adults_amount - 1 ) < 2 )
      adults_setDecreaseHidden( true );
    else
      adults_setDecreaseHidden( false );

    if ( ( adults_amount - 1 ) >= 0 )
      adults_setIncreaseHidden( false );
    else
      adults_setIncreaseHidden( true );

    guests_setText( () => guestsTextCalc( ( adults_amount-1 ), kids_amount, infants_amount ) )
  };
  const kids_handleIncrease = () => {
    kids_setAmount( kids_amount => kids_amount + 1 );

    if ( ( kids_amount + 1 ) > 0 )
      kids_setDecreaseHidden( false );
    else
      kids_setDecreaseHidden( true );

    if ( ( kids_amount + 1 ) < 30 )
      kids_setIncreaseHidden( false );
    else
      kids_setIncreaseHidden( true );

    if ( adults_amount == 0 ) {
      adults_setAmount( adults_amount => adults_amount + 1 );
      adults_setDecreaseHidden( true );
      guests_setText( () => guestsTextCalc( ( adults_amount+1 ), ( kids_amount+1 ), infants_amount ) )
    } else {
      guests_setText( () => guestsTextCalc( adults_amount, ( kids_amount+1 ), infants_amount ) )
      if ( adults_amount < 2 )
        adults_setDecreaseHidden( true );
      else
        adults_setDecreaseHidden( false );
    }
  };
  const kids_handleDecrease = () => {
    kids_setAmount( kids_amount => kids_amount - 1 );

    if ( ( kids_amount - 1 ) < 1 )
      kids_setDecreaseHidden( true );
    else
      kids_setDecreaseHidden( false );

    if ( ( kids_amount - 1 ) >= 0 )
      kids_setIncreaseHidden( false );
    else
      kids_setIncreaseHidden( true );

    if ( adults_amount == 1 )
      if ( ( kids_amount - 1 ) < 1 && infants_amount < 1 )
        adults_setDecreaseHidden( false );
      else
        adults_setDecreaseHidden( true );
    else
      adults_setDecreaseHidden( false );

    guests_setText( () => guestsTextCalc( adults_amount, ( kids_amount-1 ), infants_amount ) )
  };
  const infants_handleIncrease = () => {
    infants_setAmount( infants_amount => infants_amount + 1 );

    if ( ( infants_amount + 1 ) > 0 )
      infants_setDecreaseHidden( false );
    else
      infants_setDecreaseHidden( true );

    if ( ( infants_amount + 1 ) < 30 )
      infants_setIncreaseHidden( false );
    else
      infants_setIncreaseHidden( true );

    if ( adults_amount == 0 ) {
      adults_setAmount( prevState => prevState + 1 );
      adults_setDecreaseHidden( true );
      guests_setText( () => guestsTextCalc( ( adults_amount+1 ), kids_amount, ( infants_amount+1 ) ) )
    } else {
      guests_setText( () => guestsTextCalc( adults_amount, kids_amount, ( infants_amount+1 ) ) )

      if ( adults_amount < 2 )
        adults_setDecreaseHidden( true );
      else
        adults_setDecreaseHidden( false );
    }
  };
  const infants_handleDecrease = () => {
    infants_setAmount( infants_amount => ( infants_amount - 1 ) );

    if ( ( infants_amount - 1 ) < 1 )
      infants_setDecreaseHidden( true );
    else
      infants_setDecreaseHidden( false );

    if ( ( infants_amount - 1 ) >= 0 )
      infants_setIncreaseHidden( false );
    else
      infants_setIncreaseHidden( true );

    if ( adults_amount == 1 )
      if ( kids_amount < 1 && ( infants_amount - 1 ) < 1 )
        adults_setDecreaseHidden( false );
      else
        adults_setDecreaseHidden( true );
    else
      adults_setDecreaseHidden( false );

    guests_setText( () => guestsTextCalc( adults_amount, kids_amount, ( infants_amount-1 ) ) )
  };

  const propertiesParams = useSelector(state => state['propertiesParams']);

  useEffect(() => {
    let popoverText = [];

    let adults = parseInt(propertiesParams.adults) + parseInt(propertiesParams.kids)
    if (adults > 0) {
      popoverText.push(adults + " adults")
    }

    let infants = parseInt(propertiesParams.infants)
    if (infants > 0) {
      popoverText.push(infants + " infants")
    }

    if (popoverText.length > 0) {
      guests_setText(popoverText.join(", "));
    } else {
      guests_setText(("Who will stay"));
    }
  }, [propertiesParams])


  //-------------DIALOG-------------
  const [ dialog_open, dialog_setOpen ] = React.useState( false );
  // const [selectedValue, setSelectedValue] = React.useState(emails[1]);

  const dialog_handleOpen = () => {
    dialog_setOpen( true );
  };

  const dialog_handleClose = ( value: string ) => {
    dialog_setOpen( false );
  };

  const dispatch = useDispatch()

  const setGuestsAmountZero = () => {

    dispatch( setAdults(0) )
    dispatch( setKids(0) )
    dispatch( setInfants(0) )

    adults_setAmount( 0 );
    kids_setAmount( 0 );
    infants_setAmount( 0 );

    adults_setDecreaseHidden( true );
    kids_setDecreaseHidden( true );
    infants_setDecreaseHidden( true );

    guests_setText( () => guestsTextCalc( 0, 0, 0 ) );

    dialog_handleClose( 'close' );
  }

  const focusToggle = ( type ) => {
    if ( document !== undefined ) {
      const checkinById = document.getElementById( 'form-group-default-checkin' );
      const checkoutById = document.getElementById( 'form-group-default-checkout' );

      const checkin = document.querySelector( '.form-group-default-checkin' );
      const checkinLabel = document.querySelector( '#checkin_label' );
      const checkout = document.querySelector( '.form-group-default-checkout' );
      const checkoutLabel = document.querySelector( '#checkout_label' );

      switch ( type ) {
      case 'close_all':
        checkin.classList.remove( 'focused' );
        checkinLabel.classList.remove( 'fade' );
        checkout.classList.remove( 'focused' );
        checkoutLabel.classList.remove( 'fade' );
        checkinById.blur();
        checkoutById.blur();
        break;
      case 'close_checkin':
        checkin.classList.remove( 'focused' );
        checkinLabel.classList.remove( 'fade' );
        checkout.classList.add( 'focused' );
        checkoutLabel.classList.add( 'fade' );
        checkinById.blur();
        checkoutById.focus();
        break;
      case 'close_checkout':
        checkin.classList.add( 'focused' );
        checkinLabel.classList.add( 'fade' );
        checkout.classList.remove( 'focused' );
        checkoutLabel.classList.remove( 'fade' );
        checkinById.focus();
        checkoutById.blur();
        break;
      }
    }
  }

  const disableWeekends = ( date ) => {
    return date.getDay() === 0 || date.getDay() === 6;
  }
  const disableAllDatesAfterTwoYears = ( date ) => {
    let value = null;
    if ( Checkers.objChildExists( props, 'hasOpenCalendar' ) && !Checkers.booleanState( props.hasOpenCalendar ) ) {
      const thisDate = new Date();
      const disableAfter = new Date( thisDate.getFullYear() + 2, thisDate.getMonth(), thisDate.getDate() );
      value = new Date( date.getFullYear(), date.getMonth(), date.getDate() ) >= disableAfter;
    }

    return value;
  }

  const popover = {
    //-----POP_OVER Variables, Handlers-------
    adults: {
      handleIncrease: adults_handleIncrease,
      handleDecrease: adults_handleDecrease,
      decreaseHidden: adults_decreaseHidden,
      increaseHidden: adults_increaseHidden,
      setDecreaseHidden: adults_setDecreaseHidden,
      setIncreaseHidden: adults_setIncreaseHidden,
      setAmount: adults_setAmount,
      amount: adults_amount
    },
    kids: {
      handleIncrease: kids_handleIncrease,
      handleDecrease: kids_handleDecrease,
      decreaseHidden: kids_decreaseHidden,
      increaseHidden: kids_increaseHidden,
      setDecreaseHidden: kids_setDecreaseHidden,
      setIncreaseHidden: kids_setIncreaseHidden,
      setAmount: kids_setAmount,
      amount: kids_amount,
    },
    infants: {
      handleIncrease: infants_handleIncrease,
      handleDecrease: infants_handleDecrease,
      decreaseHidden: infants_decreaseHidden,
      increaseHidden: infants_increaseHidden,
      setDecreaseHidden: infants_setDecreaseHidden,
      setIncreaseHidden: infants_setIncreaseHidden,
      setAmount: infants_setAmount,
      amount: infants_amount,

    },
    setGuestsAmountZero: setGuestsAmountZero,
    guestsText: guests_text,
    guestsSetText: guests_setText,
    guestsTextCalc: guestsTextCalc,
    customTheme: popoverMaterialTheme,
    handleOpen: popover_handleOpen,
    handleClose: popover_handleClose,
    anchorEl: popover_anchorEl,
    open: popover_open,
    id: popover_id
  };

  const dialog = {
    handleClose: dialog_handleClose,
    handleOpen: dialog_handleOpen,
    setOpen: dialog_setOpen,
    open: dialog_open,
    customTheme: dialogMaterialTheme
  };

  const calendar = {
    value: value,
    setValue: setValue,
    customTheme: calendarMaterialTheme,
    focusToggle: focusToggle,
    disableWeekends: disableWeekends,
    disableAllDatesAfterTwoYears: disableAllDatesAfterTwoYears
  };

  const bookingBoxPosition = useSelector(
      state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_singleproperty_booking_box_position')
  );

  return (
      bookingBoxPosition == 'FIXED'
      ?
          <>
            {/*<StickyBookNow*/}
            {/*    builder={props.builder}*/}
            {/*    //---CALENDAR----*/}
            {/*    calendar={calendar}*/}
            {/*    //-----POP_OVER-------*/}
            {/*    popover={popover}*/}
            {/*    // DIALOG*/}
            {/*    dialog={dialog}*/}
            {/*    phone={props.phone}*/}
            {/*    legalLicense={props.legalLicense}*/}
            {/*/>*/}
            <SwipeableDrawerBooknow calendar={calendar} />
          </>
          :
          <>
           {<div className="col-12 col-lg-4 p-t-30">
              <BookNowViewPort
                  builder={props.builder}
                  //---CALENDAR----
                  calendar={calendar}
                  //-----POP_OVER-------
                  popover={popover}
                  // DIALOG
                  dialog={dialog}
                  phone={props.phone}
                  legalLicense={props.legalLicense}
              />
              <SwipeableDrawerBooknow calendar={calendar} />
            </div>}
          </>
  )
}

function guestsTextCalc ( adults_amount, kids_amount, infants_amount ) {
  const guests_sum =  adults_amount + kids_amount;
  if ( guests_sum > 1 && infants_amount > 1 )
    return guests_sum + ' guests, ' + infants_amount + ' infants'
  else if ( guests_sum > 1 && infants_amount == 1 )
    return guests_sum + ' guests, 1 infant'
  else if ( guests_sum == 1 && infants_amount > 1 )
    return '1 guest, ' + infants_amount + ' infants'
  else if ( guests_sum == 1 && infants_amount == 1 )
    return '1 guest, 1 infant'
  else if ( guests_sum > 1 )
    return guests_sum + ' guests'
  else if ( guests_sum == 1 )
    return '1 guest'
  else
    return 'Who'
}
